import { render, staticRenderFns } from "./DbApp.vue?vue&type=template&id=99af633e&scoped=true&"
import script from "./DbApp.vue?vue&type=script&lang=ts&"
export * from "./DbApp.vue?vue&type=script&lang=ts&"
import style0 from "./DbApp.vue?vue&type=style&index=0&id=99af633e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99af633e",
  null
  
)

export default component.exports